import { Routes, Route } from "react-router-dom";


import Page404Section from "./sections/page404Section";

function Page404App() {

  return (
    <Routes>
        <>
          <Route path="/" element={<Page404Section />} />
        </>
    </Routes>
  );
}

export default Page404App;